import { Skeleton } from "@mui/material";
import { useEffect, useState } from "react";
import { ROLE } from "../../../../../utils/constants/profiles";
import { useSelector } from "react-redux";
import CustomTotAttivitaIcon from "../../../../../app/assets/custom-icons/CustomTotAttivitaIcon";
import CustomAttApertaIcon from "../../../../../app/assets/custom-icons/CustomAttApertaIcon";
import CustomAttChiusa from "../../../../../app/assets/custom-icons/CustomAttChiusa";
import CustomAttLavorazione from "../../../../../app/assets/custom-icons/CustomAttLavorazione";
import CustomEffortStimatoIcon from "../../../../../app/assets/custom-icons/CustomEffortStimatoIcon";
import CustomEffortEffettivoIcon from "../../../../../app/assets/custom-icons/CustomEffortEffettivoIcon";

const CardTask = ({ card, loading }) => {
  const role = useSelector((state) => state.app.role);
  const appConfig = useSelector((state) => state.app.appConfig);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const [carTask, setCardTask] = useState();

  useEffect(() => {
    if (card) {
      setCardTask(
        [
          {
            id: 1,
            label: "Tot attività",
            value: card.totAttivita || card.totalPractices,
            icon: <CustomTotAttivitaIcon className="w-20 h-20" />,
          },
          {
            id: 2,
            label: "Attività aperte",
            value: card.attivitaAperte || card.openPractices,
            icon: <CustomAttApertaIcon className="w-20 h-20" />,
          },
          {
            id: 3,
            label: "Attività chiuse",
            value: card.attivitaChiuse || card.closedPractices,
            icon: <CustomAttChiusa className="w-20 h-20" />,
          },
          {
            id: 4,
            label: "In lavorazione",
            value: card.attivitaInLavorazione || card.pendingPractices,
            icon: <CustomAttLavorazione className="w-20 h-20" />,
          },
          {
            id: 5,
            label: "Effort stimato",
            value: card.totEffortStimato,
            icon: <CustomEffortStimatoIcon className="w-20 h-20" />,
          },
          {
            id: 6,
            label: "Effort effettivo",
            value: card.totEffortEffettivo,
            icon: <CustomEffortEffettivoIcon className="w-20 h-20" />,
          },
        ].filter(
          (el) =>
            !(
              (role === ROLE.USER || !appConfig?.modules?.practice?.subtask) &&
              (el.id === 5 || el.id === 6)
            )
        )
      );
    }
  }, [card, role, appConfig]);

  return (
    <div className="flex flex-wrap py-3">
      {carTask?.map((el) => (
        <div className="m-4" key={el.id}>
          <div
            className="shadow-md w-full h-44 rounded-xl p-3"
            style={{ minWidth: "16rem", maxWidth: "30rem" }}
          >
            {loading ? (
              <Skeleton variant="rectangular" width={180} height={25} />
            ) : (
              <p className="text-2xl font-bold m-0">{el.label}</p>
            )}
            <div className="flex justify-around items-center py-4">
              {el.icon}

              {loading ? (
                <Skeleton variant="circular" width={60} height={60} />
              ) : (
                <p
                  className="text-4xl font-bold m-0"
                  style={{ color: colorPrimary }}
                >
                  {el.value}
                </p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardTask;
